import React from "react";
import { BsCloudUpload, BsFileEarmarkArrowUp } from "react-icons/bs";
import ToolMenuIconButton from "../../../../common/ToolMenuIconButton";
import { AppConfig } from "../../../../../common/constants";

export interface IProps {
  /**
   * 選択したファイルが変更された場合に呼び出されます
   */
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

class UploadFileButton extends React.Component<IProps> {
  private readonly IsCloud = AppConfig.MODE === AppConfig.MODE_CLOUD;
  private readonly Icon = this.IsCloud ? (
    <BsCloudUpload />
  ) : (
    <BsFileEarmarkArrowUp />
  );
  private readonly Tooltip = this.IsCloud ? "Upload Files" : "Import Files";
  private inputRef = React.createRef<HTMLInputElement>();

  constructor(props: IProps) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClick(): void {
    this.inputRef.current?.click();
  }

  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    this.props.onChange(e);
    if (this.inputRef.current) {
      this.inputRef.current.value = "";
    }
  }

  render(): JSX.Element {
    return (
      <div>
        <ToolMenuIconButton
          onClick={this.handleClick}
          icon={this.Icon}
          tooltip={this.Tooltip}
        />
        <input
          type="file"
          multiple={true}
          accept={AppConfig.UPLOAD_FILES_EXTENSION}
          ref={this.inputRef}
          onChange={this.handleChange}
          style={{ display: "none" }}
        />
      </div>
    );
  }
}

/**
 * ファイルアップロードボタン
 */
export default UploadFileButton;
